<template>
    <div class="imageCol">
        <div v-if="isCarCutterThumb" class="auctionImgDiv">
            <div class="carCutterImgDiv">
                <img :src="thumbnail" :vin="car.VIN" alt="" @error="imageUrlAlt" @decode="nowImageReady" class="carCutterImg"/>
                <caching-image-indicator v-if="!imageReady"/><!--v-if="needImageCaching || !imageReady"/>-->
            </div>
        </div>
        <div v-else class="auctionImgDiv">
            <img :src="thumbnail" :vin="car.VIN" alt="" @error="imageUrlAlt" @load="nowImageReady" class="auctionImg"/>
            <caching-image-indicator v-if="!imageReady"/><!--v-if="needImageCaching || !imageReady"/>-->
        </div>
    </div>
</template>

<script>
    import CachingImageIndicator from './CachingImageIndicator.vue'
    //import config from '../config'

    export default {
        props: [
            'car',
            'carIndex'
        ],
        data() {
            return {
                thumbnail: this.car.cached_thumbnail, 
                imageReady: false,
                isCarCutterThumb: false
            }
        },
        components: {
            'caching-image-indicator': CachingImageIndicator
        },
        /*mounted() {
            if(this.needImageCaching) {
                console.log(this.car.VIN + " MOUNTED NEEDS IMAGE CACHED");
                //this.cacheVehcileImages();
            }
        },*/
        /*computed: {
            needImageCaching() {*/
                /*if(this.car.cached_thumbnail.includes('BlueBlanket')) {
                    console.log("FOUND BLUE BLANKET THUMBNAIL for " + this.car.VIN);

                    if(this.car.thumbpath.includes(".jpg")) {
                        console.log("FOUND VALID IMAGE URL IN THUMBPATH ... RE-CAHING NEEDED");
                        return true;
                    }
                }*/
                
        /*        return this.thumbnail == null;
            }
        },*/
        watch: {
            imageReady(nowReady, wasReady) {
                if(wasReady != nowReady && nowReady) {
                    if(this.thumbnail.match(/mccluskey-carcutter/)) {
                        this.isCarCutterThumb = true;
                    }
                }
            }
        },
        methods: {
			imageUrlAlt(event) {
				event.target.src = "/pictures_coming_soon.png"
            },
            nowImageReady() {
                this.imageReady = true;
            },
            /*async cacheVehcileImages () {
                try {
                    const response = await config.clientAdminApi.post('v2/cars/cacheImages', {vehicle: JSON.stringify(this.car)})
                                                .catch(function(error) {
                                                    console.log('Error getting vehicles images ran through cloudinary object detection and cached.' + error);
                                                });
                            
                    if(response) {
                        let cachedImages = response.data.cachedImages;
                        //console.log("Cached Images Response " + JSON.stringify(response.data.cachedImages));

                        this.thumbnail = cachedImages.cached_thumbnail;
                        this.$store.commit('updateCachedImagesForVehicle', {matchIndex : this.carIndex, cachedImages: cachedImages})
                    }
                    else {
                        console.log("Error getting vehicles images ran through cloudinary object detection and cached. No repsponse from server.");
                    }
                }
                catch(e) {
                    console.log("Error getting vehicles images ran through cloudinary object detection and cached. No repsponse from server.");
                    console.log(JSON.stringify(e));
                }
            }*/
        }
    }
</script>

<style>
    .auctionImgDiv {
        height: inherit;
        width: inherit;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
    }

    .carCutterImgDiv {
        background: radial-gradient(250% 100% at bottom, #333, #333 10%, #BEBEBE 66%, transparent 34%), 
                    linear-gradient(to top, #BEBEBE 60%, #eee 64%, #DEDEDE 96%); 
        
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: calc(((16 * (1.4 - var(--vratio))) - .4)* var(--vh));/*inherit;*/
        width: calc(((((16 * (1.4 - var(--vratio))) / 3) * 4) - .4)* var(--vh));/*inherit;*/
    }

    .inmobile .carCutterImgDiv {
        height: inherit;
        width: inherit;
    }

    .carCutterImg {
        max-height: 92%;
        padding: 2%;
    }

    .auction_page_link {
        font-weight: bold;
        font-size: .9em;
        color: var(--mccluskeyBlue); /*#2291d6;*/
        text-decoration: none;
	}
    
    .imageCol {
        height: calc((16 * (1.4 - var(--vratio))) * var(--vh));/*calc((16 * .9) * var(--vh));*/
        width: calc((((16 * (1.4 - var(--vratio))) / 3) * 4) * var(--vh));/*calc((((16 * .9) / 3) * 4) * var(--vh));*/
    }

    .inmobile .imageCol {
        height: calc(96vw * (3/4));/*calc(16 * var(--vh));*/
        width: 96vw;/*calc((16 / 3) * 4 * var(--vh));*/
        margin: 2vw;
    }

    /*.imageCol img {*/
    .imageCol .auctionImg {
        height: calc(((16 * (1.4 - var(--vratio))) - .4)* var(--vh));/*inherit;*/
        width: calc(((((16 * (1.4 - var(--vratio))) / 3) * 4) - .4)* var(--vh));/*inherit;*/
        cursor: pointer;
        object-fit: cover;
    }

    .inmobile .imageCol img {
        height: inherit;
        width: inherit;
    }
    
    .imageCol .crash {
        vertical-align: top;
        position: absolute;
        right: 5px;
        top: 20px;
        display: inline-block;
        background: url(/images/mini_x_button_red.png) no-repeat top left;
        width: 10px;
        height: 10px;
        text-indent: -9000%;
    }
    
    .imageCol .crash:hover {
        background-position: bottom left;
    }
</style>